import React from "react";
import _lowerCase from "lodash/lowerCase";
import ReactHighcharts from "react-highcharts";
import ReactTooltip from "react-tooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/pro-solid-svg-icons";
import PropTypes from "prop-types";
import { OUTCOMES } from "./Expectations";
import styles from "../../styles/components/ExpectationsGraph.css";

export function KeyTooltipContent() {
    return (
        <ReactTooltip
            border
            id="key"
            type="light"
            place="bottom"
            effect="solid"
            multiline
        >
            <div style={{ maxWidth: 200 }}>
                <h4>How do I read this chart?</h4>
                <ul>
                    <li style={{ textAlign: "left" }}>
                        The length of each bar reflects the number of visitors
                        who mentioned that hope or concern.
                    </li>
                    <br />
                    <li style={{ textAlign: "left" }}>
                        The segments of each bar reflect the number of vistors
                        who listed that concern and found that the page either
                        met, didn't meet, or somewhat met their expectation.
                    </li>
                </ul>
                <br />
                <h5 style={{ textAlign: "left" }}>Legend</h5>
                <ul className={styles.keyTooltip}>
                    {OUTCOMES.map(outcome => (
                        <li className={styles.chartKey} key={outcome.value}>
                            <div
                                style={{ backgroundColor: outcome.color }}
                                className={styles.chartKeyDash}
                            />
                            <p className={styles.chartKeyLabel}>
                                {outcome.label}
                            </p>
                        </li>
                    ))}
                </ul>
            </div>
        </ReactTooltip>
    );
}

function buildSeries(expectations) {
    return OUTCOMES.slice()
        .reverse()
        .map(outcome => {
            return {
                name: outcome.value,
                color: outcome.color,
                data: expectations.map(expectation => {
                    const { totalMentions } = expectation;
                    const mentionCount = expectation[outcome.value];
                    return {
                        y: mentionCount,
                        addressLabel: outcome.label,
                        percentage:
                            totalMentions > 0
                                ? (mentionCount / totalMentions) * 100
                                : 0
                    };
                })
            };
        });
}

export default function ExpectationsGraph({ expectations }) {
    const themeLabels = expectations.map(expectation => {
        return expectation.theme;
    });

    const config = {
        chart: {
            type: "bar",
            height: 300
        },
        credits: { enabled: false },
        legend: { enabled: false },
        title: { text: "" },
        xAxis: {
            categories: themeLabels,
            tickWidth: 0,
            labels: {
                style: {
                    fontSize: "14px"
                }
            }
        },
        yAxis: {
            min: 0,
            title: {
                text: "Importance",
                margin: 20,
                style: {
                    fontSize: "14px"
                }
            },
            labels: {
                enabled: false
            },
            gridLineWidth: 0,
            lineWidth: 1
        },
        series: buildSeries(expectations),
        tooltip: {
            useHTML: true,
            outside: true,
            formatter: function() {
                const addressLabel = _lowerCase(this.point.addressLabel);
                const percentage = Math.round(this.point.percentage);
                return `<b>${this.x}:</b> ${percentage}% ${addressLabel}`;
            }
        },
        plotOptions: {
            series: {
                stacking: "normal",
                groupPadding: 0,
                minPointWidth: 20,
                maxPointWidth: 30
            }
        }
    };
    return (
        <div className={styles.chart}>
            <a className={styles.key} data-tip="key-tooltip" data-for="key">
                <p className={styles.keyLabel}>
                    key <FontAwesomeIcon icon={faInfoCircle} />
                </p>
            </a>
            <KeyTooltipContent />
            <ReactHighcharts config={config} />
        </div>
    );
}

ExpectationsGraph.propTypes = {
    expectations: PropTypes.arrayOf(
        PropTypes.shape({
            theme: PropTypes.string.isRequired,
            numMet: PropTypes.number.isRequired,
            numSomewhat: PropTypes.number.isRequired,
            numUnmet: PropTypes.number.isRequired,
            totalMentions: PropTypes.number.isRequired
        })
    )
};



// WEBPACK FOOTER //
// ./src/components/Results/ExpectationsGraph.js